<div class="dialog-header">
  <h1 mat-dialog-title>Notes de version {{ data.version }}</h1>
  <button mat-icon-button (click)="close()" matTooltip="Fermer" class="close-button" data-testid="release-notes-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="content-wrapper" [innerHTML]="data.details"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" class="action-button" data-testid="release-notes-understand-button">J'ai compris</button>
</mat-dialog-actions>
